<template>
  <div class="ws-exam-groups-wrapper">
    <div
      class="ws-exam-groups-meta"
      v-if="exam"
    >
      <div class="columns">
        <div class="column is-12">
          <header class="ws-exam-groups-header">
            <div class="columns">
              <div class="column is-10">
                <ws-demo-exam-status :exam="exam" />
                <h1 class="ws-exam-groups-header__title has-text-weight-bold is-size-2">
                  <span v-if="exam.name">
                    <span>ID {{exam.human_readable_id}} - </span>
                    <span v-text="exam.name.display"></span>
                    <span>: </span>
                  </span>
                  <span
                    style="margin: 0 20px"
                    v-text="$t('Экзаменационные группы')"
                  ></span>
                  &nbsp;
                  <ws-role-node :only="['front_admin', 'front_dep']">
                    <!-- <router-link
                      :to="`/demo-exams/${exam.guid}/logs`"
                      class="ws-button button "
                    >
                      <ws-icon
                        class="ws-button__icon"
                        name="clock"
                        :fill="true"
                        width="16"
                        height="16"
                      />
                      &nbsp;
                      <span
                        class="is-size-4 has-text-weight-normal"
                        v-text="$t(`Журнал Изменений`)"
                      ></span>
                    </router-link> -->
                  </ws-role-node>
                </h1>
                <p
                  class="ws-demo-exams__item-competence"
                  v-if="exam.accred_comps && exam.accred_comps.competency"
                >
                  <span
                    class="has-text-grey"
                    v-text="exam.accred_comps.competency.code"
                  ></span>&nbsp;
                  <span v-text="exam.accred_comps.competency.name.display"></span>&nbsp;
                  <span
                    class="has-text-grey"
                    v-text="exam.accred_comps.competency.name.second"
                  ></span>
                </p>
              </div>
              <div class="column is-2">
                <dl class="ws-demo-exams-meta">
                  <dt
                    class="has-text-grey is-size-5"
                    v-text="$t('День ПД')"
                  ></dt>
                  <dd
                    class="is-size-4 has-text-black"
                    v-if="exam.day_cm1"
                  >
                    <ws-time-formatter
                      :date="exam.day_cm1"
                      format="LL"
                    />
                  </dd>
                </dl>
                <dl class="ws-demo-exams-meta">
                  <dt
                    class="has-text-grey is-size-5"
                    v-text="$t('Дата начала')"
                  ></dt>
                  <dd
                    class="is-size-4 has-text-black"
                    v-if="exam.started_at"
                  >
                    <ws-time-formatter
                      :date="exam.started_at"
                      format="LL"
                    />
                  </dd>
                </dl>
                <dl class="ws-demo-exams-meta">
                  <dt
                    class="has-text-grey is-size-5"
                    v-text="$t('Дата окончания')"
                  ></dt>
                  <dd
                    class="is-size-4 has-text-black"
                    v-if="exam.ended_at"
                  >
                    <ws-time-formatter
                      :date="exam.ended_at"
                      format="LL"
                    />
                  </dd>
                </dl>
              </div>
            </div>
            <div class="tabs">
              <ul class="tabs__content">
                <li
                  v-for="(tab, index) in tabs"
                  :key="index"
                  class='tabs__item is-uppercase has-text-weight-bold ml-3'
                  :class='{"active" : tab.link === activeTab}'
                  @click="activeTab = tab.link"
                >
                  <span v-if="tab.link === 'documents'">{{ tab.title }}
                    <span
                      class="doc-count"
                      :class="docCounting.total === docCounting.count ? 'has-text-success' : 'has-text-danger'">
                        ({{docCounting.count}}/{{docCounting.total}})
                      </span>
                  </span>
                  <span v-else>{{ tab.title }}</span>
                </li>
                <ws-role-node :only="['front_admin', 'front_dep']">
                  <li
                    class='tabs__item is-uppercase has-text-weight-bold ml-5'
                    :class='{"active" :  activeTab === "journal"}'
                    @click="activeTab = 'journal'"
                  >
                    <span>{{this.$t('Журнал')}}</span>
                  </li>
                </ws-role-node>
              </ul>
            </div>
          </header>
          <template v-if="activeTab === 'exam'">
            <p
              class="ws-demo-exams__item-de-center is-marginless"
              v-if="exam.de_center"
            >
              <span>{{ $t('Статус ЦПДЭ:')}}</span>
              <ws-accreditation :accred_comps="exam.accred_comps" :exam="exam" />
              <br />
              <span>{{ $t('ЦПДЭ: ')}}</span>
              <span
                  class="has-text-weight-bold inline-flex"
                >
                  <ws-icon
                    v-if="!exam.de_center.visible"
                    name="minus-circle"
                    width="12"
                    height="12"
                    class="minus-circle-ico"
                  />
                  <span>{{exam.de_center.name.display}}</span>
                </span><br>
              <span v-if="exam.de_center.address.region">
                <span v-text="exam.de_center.address.region.title.display"></span>,&nbsp;
              </span>
              <span v-if="exam.de_center.address.district">
                <span v-text="exam.de_center.address.district.title.display"></span>,&nbsp;
              </span>
              <span v-if="exam.de_center.address.locality">
                {{ exam.de_center.address.locality.title.display.replace('г,', 'г.').replace(', ,', ',') }}
              </span>
              <span v-if="exam.de_center.address">
                {{ exam.de_center.address.address.display.replace('ул,', 'ул.').replace('д,', 'д.').replace(', ,', ',') }}
              </span>
            </p>
            <div class="ws-exam-groups-meta__experts">
              <div class="ws-exam-groups-meta__item is-6">
                <div class="columns">
                  <div
                    class="column is-narrow"
                    style="padding-right: 0"
                  >
                    <span v-text="$t('ГЭ')"></span>:&nbsp;
                  </div>
                  <div class="column is-narrow">
                    <div class="columns">
                      <div
                        class="column"
                        style="padding-left: 7px"
                      >
                        <strong
                          class="has-text-success"
                          v-if="exam.main_expert && exam.main_expert.user_info"
                        >
                          <span v-if="exam.main_expert.user_info.last.display">
                            {{ exam.main_expert.user_info.last.display }}
                          </span>
                          <span v-if="exam.main_expert.user_info.first.display">
                            {{ exam.main_expert.user_info.first.display }}
                          </span>
                          <span v-if="exam.main_expert.user_info.middle.display">
                            {{ exam.main_expert.user_info.middle.display }}
                          </span>
                          <span
                            class="has-text-grey has-text-weight-normal"
                            v-if="exam.main_expert.region && exam.main_expert.region.title.display"
                          >({{ exam.main_expert.region.title.display }})</span><br>
                          <span
                            class="has-text-black has-text-weight-normal"
                            v-if="getPhoneNumber(exam.main_expert)"
                          >{{ getPhoneNumber(exam.main_expert) }}, </span>
                          &nbsp;<span class="has-text-primary has-text-weight-normal">{{ exam.main_expert.user_info.email }}</span>
                        </strong>
                        <strong
                          class="has-text-danger"
                          v-else
                          v-text="$t('Не запрошен')"
                        ></strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ws-exam-groups-meta__item is-4">
                <span v-text="$t('Эксперты: ')"></span>
                <b-dropdown
                  class="ws-participants__dropdown"
                  v-if="exam.experts && exam.experts.length"
                  aria-role="list"
                >
                  <span
                    class="is-hoverable"
                    slot="trigger"
                    role="button"
                  >
                    <span
                      class="has-text-primary"
                      v-text="exam.experts.length"
                    ></span>
                  </span>
                  <b-dropdown-item
                    custom
                    v-for="expert in exam.experts"
                    :value="expert"
                    :key="expert.guid"
                    aria-role="listitem"
                  >
                    <div class="media">
                      <div class="media-left">
                        <figure class="image is-48x48">
                          <ws-avatar
                            v-if="expert.user_info"
                            :id="expert.user_info.guid"
                            :name="`${ expert.user_info.first.display } ${expert.user_info.last.display}`"
                            sizeType="Small"
                            :size="48"
                          />
                        </figure>
                      </div>
                      <div
                        class="media-content"
                        v-if="expert.user_info"
                      >
                        <strong>{{ expert.user_info.last.display }}</strong><br>
                        <span>{{ expert.user_info.first.display }}</span><span>&nbsp;</span>
                        <span>{{ expert.user_info.middle.display }}</span>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
                <strong v-else>
                  <span
                    class="has-text-danger"
                    v-text="$t('Не назначены')"
                  ></span>
                </strong>
              </div>
              <div class="ws-exam-groups-meta__item is-4">
                <span v-text="$t('Технические эксперты: ')"></span>
                <b-dropdown
                  class="ws-participants__dropdown"
                  v-if="exam.technical_experts && exam.technical_experts.length"
                  aria-role="list"
                >
                  <span
                    class="is-hoverable"
                    slot="trigger"
                    role="button"
                  >
                    <span
                      class="has-text-primary"
                      v-text="exam.technical_experts.length"
                    ></span>
                  </span>
                  <b-dropdown-item
                    custom
                    v-for="expert in exam.technical_experts"
                    :value="expert"
                    :key="expert.guid"
                    aria-role="listitem"
                  >
                    <div
                      class="media"
                      v-if="expert.user_info"
                    >
                      <div class="media-left">
                        <figure class="image is-48x48">
                          <ws-avatar
                            :id="expert.guid"
                            :name="`${ expert.user_info.first.display } ${expert.user_info.last.display}`"
                            sizeType="Small"
                            :size="48"
                          />
                        </figure>
                      </div>
                      <div class="media-content">
                        <strong>{{ expert.user_info.last.display }}</strong><br>
                        <span>{{ expert.user_info.first.display }}</span><span>&nbsp;</span>
                        <span>{{ expert.user_info.middle.display }}</span><br>
                        <span>{{ expert.user_info.email }}</span><br>
                        <span>{{ getTechnicalExpertPhoneNumbers(expert) }}</span>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
                <strong v-else>
                  <span
                    class="has-text-danger"
                    v-text="$t('Не добавлены')"
                  ></span>
                </strong>
              </div>
            </div>
            <WsReadinessCPDEForm :exam="exam"/>

            <ws-exam-participants-info :shifts="exam.shifts" />

            <div
              class="ws-exam-groups-meta__docs"
              v-if="!isExam50Plus"
            >
              <!-- <h3 class="ws-exam-groups-meta__docs__title has-text-weight-bold is-size-2">{{ $t('Отчетные документы: ') }}</h3>
              <dl class="ws-exam-groups-meta__docs__item">
                <dt>
                  <span class="is-size-3">{{ $t('Акт готовности площадки:')}}</span>
                </dt>
                <dd v-if="files.reports && files.reports.length">
                  <span class="has-text-success has-text-weight-bold">{{ $t('Загружен')}} </span>
                  <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                    <file-download
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                      class="is-size-3 is-inline-block"
                      :file="files.reports[0]"
                      :isShowFileDate="true"
                      :buttonLabel="''"
                      @remove="removeFile('reports')"
                    />
                  </ws-role-node>
                  <ws-role-node :except="['front_me', 'front_dep', 'front_admin', 'front_mc']">
                    <file-download
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                      class="is-size-3 is-inline-block remove-disabled"
                      :isShowFileDate="true"
                      :file="files.reports[0]"
                      :buttonLabel="''"
                    />
                  </ws-role-node>
                </dd>
                <dd v-else>
                  <span class="has-text-danger has-text-weight-bold">{{ $t('Не загружен')}}&nbsp;</span>
                  <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
                    <file-upload
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                      class="is-inline-block"
                      :category="'de-reports'"
                      :item-guid="exam.guid"
                      :path-url="`/api/de/proxy/general-files/add/category/`"
                      @uploaded="uploadFile"
                      :buttonLabel="$t('Загрузить')"
                      accept="application/pdf"
                    />
                  </ws-role-node> -->
                  <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                    <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                  </ws-role-node>-->
                <!-- </dd>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
            <dt>
              <span class="is-size-3">{{ $t('Отчет ГЭ по итогам проведения ДЭ:')}}</span>
            </dt>
            <dd v-if="files.docs && files.docs.length">
              <span class="has-text-success has-text-weight-bold">{{ $t('Загружен')}} </span>
              <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                <file-download
                  :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                  class="is-size-3 is-inline-block"
                  :file="files.docs[0]"
                  :isShowFileDate="true"
                  :buttonLabel="''"
                  @remove="removeFile('docs')"
                />
              </ws-role-node>
              <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                <file-download
                  :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                  class="is-size-3 is-inline-block remove-disabled"
                  :isShowFileDate="true"
                  :file="files.docs[0]"
                  :buttonLabel="''"
                />
              </ws-role-node>
            </dd>
            <dd v-else>
              <span class="has-text-danger has-text-weight-bold">{{ $t('Не загружен')}}&nbsp;</span>
              <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                <file-upload
                  :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                  class="is-inline-block"
                  :category="'de-docs'"
                  :item-guid="exam.guid"
                  @uploaded="uploadFile"
                  :path-url="`/api/de/proxy/general-files/add/category/`"
                  :buttonLabel="$t('Загрузить')"
                  accept="application/pdf"
                />
              </ws-role-node> -->
              <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
              </ws-role-node>-->
            <!-- </dd> -->
              <!-- </dl> -->
              <dl
                class="ws-exam-groups-meta__docs__item"
                v-if="isNoc"
              >
                <dt>
                  <span class="is-size-3">{{ $t('Протокол проведения профессионального экзамена НОК:')}}</span>
                </dt>
                <dd v-if="files['docs-noc'] && files['docs-noc'].length">
                  <span class="has-text-success has-text-weight-bold">{{ $t('Загружен')}} </span>
                  <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                    <file-download
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                      class="is-size-3 is-inline-block"
                      :file="files['docs-noc'][0]"
                      :isShowFileDate="true"
                      :buttonLabel="''"
                      @remove="removeFile('docs-noc')"
                    />
                  </ws-role-node>
                  <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                    <file-download
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                      class="is-size-3 is-inline-block remove-disabled"
                      :isShowFileDate="true"
                      :file="files['docs-noc'][0]"
                      :buttonLabel="''"
                    />
                  </ws-role-node>
                </dd>
                <dd v-else>
                  <span class="has-text-danger has-text-weight-bold">{{ $t('Не загружен')}}&nbsp;</span>
                  <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
                    <file-upload
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                      class="is-inline-block"
                      :category="'de-docs-noc'"
                      :item-guid="exam.guid"
                      @uploaded="uploadFile"
                      :buttonLabel="$t('Загрузить')"
                      accept="application/pdf"
                    />
                  </ws-role-node>
                  <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                    <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                  </ws-role-node>-->
                </dd>
              </dl>
              <b-loading
                :active="isUploadPending"
                :is-full-page="false"
                :can-cancel="true"
              ></b-loading>
            </div>

            <div class="links">
              <div class="description"><b>Прямая URL ссылка на видеотрансляцию экзамена:</b></div>

              <div v-if="currentRole === 'front_rcc' ||
                      currentRole === 'front_curator' ||
                      currentRole === 'front_me' ||
                      currentRole === 'front_dep' ||
                      currentRole === 'front_admin'
                      ">

                <div
                  v-for="(link, index) in videoLinks"
                  :key="index"
                >
                  <div class="videoLink">

                    <b-input
                      v-if="link.isOpen"
                      v-model="link.link"
                      name="comment"
                      placeholder="Ссылка на видеотрансляцию"
                    />
                    <a
                      v-else
                      style="color: #1c3b8d"
                      :href="link.link"
                      target="_blank"
                    >
                      {{link.link}}
                    </a>

                    <button
                      v-if="!link.isOpen"
                      class="ws-button button is-text"
                      type="button"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      @click="openLink(index)"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="edit"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>

                    <button
                      v-if="link.isOpen"
                      class="ws-button button is-text"
                      type="button"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      @click="saveLink(link, index)"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="check-mark"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>

                    <button
                      class="ws-button button is-text"
                      type="button"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      @click="deleteLink(link, index)"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="trash"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>
                  </div>
                </div>

                <button
                  v-if="(videoLinks.length === 0 || videoLinks[videoLinks.length - 1].link) && videoLinks.length < 20"
                  class="ws-button button is-text"
                  type="button"
                  :disabled="isBlockedStatus || !isMyDeCenter"
                  @click="addNewLink()"
                >
                  <ws-icon
                    class="ws-button__icon is-position-left"
                    name="plus-circle"
                    color="#1c3b8d"
                    width="20"
                    height="20"
                  />
                  <strong
                    class="ws-button__text has-text-primary"
                    v-text="$t('Добавить ссылку')"
                  ></strong>
                </button>
              </div>

              <div v-else>
                <div
                  v-for="(link, index) in videoLinks"
                  :key="index"
                  class="videoLink"
                >
                  <a
                    style="color: #1c3b8d"
                    :href="link.link"
                    target="_blank"
                  >
                    {{link.link}}
                  </a>
                </div>
              </div>
            </div>

            <div class="comments">

              <div v-if="currentRole === 'front_rcc' ||
                      currentRole === 'front_curator' ||
                      currentRole === 'front_me' ||
                      currentRole === 'front_dep' ||
                      currentRole === 'front_admin'
                      ">
                <div class="description"><b>Комментарий (при необходимости):</b></div>

                <div
                  v-for="(comment, index) in comments"
                  :key="index"
                  class="comment"
                >
                  <template v-if="comment.isOpen">

                    <textarea
                      v-model="comment.comment"
                      name="comment"
                      maxlength="10000"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      rows="4"
                      cols="40"
                    />
                    <button
                      class="ws-button button is-text"
                      type="button"
                      @click="saveComment(comment, index)"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      v-if="comment.isOpen"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="check-mark"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>

                    <button
                      class="ws-button button is-text"
                      type="button"
                      @click="deleteComment(comment, index)"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      v-if="comment.guid !== null"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="trash"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>
                  </template>

                  <template v-else>
                    <div class="commentText">
                      {{comment.comment}}
                    </div>

                    <button
                      class="ws-button button is-text"
                      type="button"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      @click="openComment(index)"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="edit"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>
                    <button
                      class="ws-button button is-text"
                      type="button"
                      :disabled="isBlockedStatus || !isMyDeCenter"
                      @click="deleteComment(comment,index)"
                      v-if="comment.guid !== null"
                    >
                      <ws-icon
                        class="ws-button__icon is-position-left"
                        name="trash"
                        color="#1c3b8d"
                        width="15"
                        height="15"
                      />
                    </button>
                  </template>
                </div>
              </div>

              <div v-else>
                <div class="description"><b>Комментарий:</b></div>
                <div
                  v-for="(comment, index) in comments"
                  :key="index"
                >
                  <div class="commentText">
                    {{comment.comment}}
                  </div>
                </div>
              </div>
            </div>

            <div class="ws-exam-groups-approve">
              <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
                <p
                  class="is-size-3"
                  v-if="exam.status === 'confirmed_auth_org'"
                >
                  {{$t('Главный эксперт подтверждает присутствие участников на площадке в день ПД.')}}<br>
                  {{$t('После чего необходимо подтвердить проведение экзамена нажав на кнопку ниже:')}}
                </p>
              </ws-role-node>
              <div class="buttons">
                <ws-demo-exams-approve
                  style="margin-right: 1rem;"
                  :files="files"
                  :exam="exam"
                  :is-show-complete="true"
                  :is-show-status="true"
                  @update="_fetch"
                ></ws-demo-exams-approve>
                <ws-role-node :only="['front_dep']">
                  <button
                    class="ws-button button is-text"
                    :class="{'is-loading': isStatusUpdating }"
                    v-if="exam.status === constants.exam_status.CONFIRMED_AUTH_ORG || exam.status === constants.exam_status.CONFIRMED_AUTH_ORG_BLOCKED"
                    :disabled="isBlockedStatus || !isMyDeCenter"
                    @click="updateExamStatus(exam,'revision_de_department')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="close"
                      color="#1c3b8d"
                      width="20"
                      height="20"
                    />
                    <span
                      class="ws-button__text has-text-primary"
                      v-text="$t('Вернуть на доработку')"
                    ></span>
                  </button>
                </ws-role-node>
              </div>
            </div>
          </template>
          <ws-experts-list :isMyDeCenter="isMyDeCenter" v-show="activeTab === 'experts'" :exam="exam" :expert="expert" />
          <template v-if="activeTab === 'documents'">
            <div
              class="ws-exam-groups-meta__docs new-docs"
              v-if="!isExam50Plus"
            >
              <h3 class="ws-exam-groups-meta__docs__title is-size-3">{{ $t('Документы ') }}</h3>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                      class="ws-field"
                      :label="$t('Тип документа')"
                      :type="{'is-danger': errors.has('type')}"
                      :message="errors.first('type')"
                    >
                      <b-select
                        class="ws-field__control"
                        name="type"
                        :placeholder="$t('')"
                        value='1'
                        expanded
                        disabled
                      >
                        <option
                          value="1"
                          v-text="'Акт результатов проверки ЦПДЭ (можно скачать в ЦСО)'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-reports'] && files['de-reports'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block"
                        :file="files['de-reports'][0]"
                        :isShowFileDate="true"
                        :buttonLabel="''"
                        @remove="removeFile('de-reports')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block remove-disabled"
                        :isShowFileDate="true"
                        :file="files['de-reports'][0]"
                        :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                        :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-reports'] && files['de-reports'].length)"
                        class="is-full"
                        :category="'de-reports'"
                        :item-guid="exam.guid"
                        :path-url="`/api/de/proxy/general-files/add/category/`"
                        @uploaded="uploadFile"
                        :buttonLabel="$t('Загрузить .pdf')"
                        accept="application/pdf"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                      class="ws-field"
                      :label="$t('Тип документа')"
                      :type="{'is-danger': errors.has('type')}"
                      :message="errors.first('type')"
                    >
                      <b-select
                        class="ws-field__control"
                        name="type"
                        :placeholder="$t('')"
                        value='1'
                        expanded
                        disabled
                      >
                        <option
                          value="1"
                          v-text="'Протокол проведения ДЭ'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-docs'] && files['de-docs'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block"
                        :file="files['de-docs'][0]"
                        :isShowFileDate="true"
                        :buttonLabel="''"
                        @remove="removeFile('de-docs')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block remove-disabled"
                        :isShowFileDate="true"
                        :file="files['de-docs'][0]"
                        :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                        :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-docs'] && files['de-docs'].length)"
                        class="is-full"
                        :category="'de-docs'"
                        :item-guid="exam.guid"
                        @uploaded="uploadFile"
                        :path-url="`/api/de/proxy/general-files/add/category/`"
                        :buttonLabel="$t('Загрузить .pdf')"
                        accept="application/pdf"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                        class="ws-field"
                        :label="$t('Тип документа')"
                        :type="{'is-danger': errors.has('type')}"
                        :message="errors.first('type')"
                    >
                      <b-select
                          class="ws-field__control"
                          name="type"
                          :placeholder="$t('')"
                          value='1'
                          expanded
                          disabled
                      >
                        <option
                            value="1"
                            v-text="'Паспорт ЦПДЭ и сведения о материально-техническом обеспечении и расходных материалах'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-docs-mto'] && files['de-docs-mto'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block"
                          :file="files['de-docs-mto'][0]"
                          :isShowFileDate="true"
                          :buttonLabel="''"
                          @remove="removeFile('de-docs-mto')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block remove-disabled"
                          :isShowFileDate="true"
                          :file="files['de-docs-mto'][0]"
                          :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                          :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-docs-mto'] && files['de-docs-mto'].length)"
                          class="is-full"
                          :category="'de-docs-mto'"
                          :item-guid="exam.guid"
                          @uploaded="uploadFile"
                          :path-url="`/api/de/proxy/general-files/add/category/`"
                          :buttonLabel="$t('Загрузить .pdf')"
                          accept="application/pdf"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                        class="ws-field"
                        :label="$t('Тип документа')"
                        :type="{'is-danger': errors.has('type')}"
                        :message="errors.first('type')"
                    >
                      <b-select
                          class="ws-field__control"
                          name="type"
                          :placeholder="$t('')"
                          value='1'
                          expanded
                          disabled
                      >
                        <option
                            value="1"
                            v-text="'Паспорт ЦПДЭ'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-docs-passport'] && files['de-docs-passport'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block"
                          :file="files['de-docs-passport'][0]"
                          :isShowFileDate="true"
                          :buttonLabel="''"
                          @remove="removeFile('de-docs-passport')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block remove-disabled"
                          :isShowFileDate="true"
                          :file="files['de-docs-passport'][0]"
                          :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                          :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-docs-passport'] && files['de-docs-passport'].length)"
                          class="is-full"
                          :category="'de-docs-passport'"
                          :item-guid="exam.guid"
                          @uploaded="uploadFile"
                          :path-url="`/api/de/proxy/general-files/add/category/`"
                          :buttonLabel="$t('Загрузить .xlsx')"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                        class="ws-field"
                        :label="$t('Тип документа')"
                        :type="{'is-danger': errors.has('type')}"
                        :message="errors.first('type')"
                    >
                      <b-select
                          class="ws-field__control"
                          name="type"
                          :placeholder="$t('')"
                          value='1'
                          expanded
                          disabled
                      >
                        <option
                            value="1"
                            v-text="'Сведения о материально-техническом обеспечении (МТО)'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-mto'] && files['de-mto'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block"
                          :file="files['de-mto'][0]"
                          :isShowFileDate="true"
                          :buttonLabel="''"
                          @remove="removeFile('de-mto')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block remove-disabled"
                          :isShowFileDate="true"
                          :file="files['de-mto'][0]"
                          :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                          :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-mto'] && files['de-mto'].length)"
                          class="is-full"
                          :category="'de-mto'"
                          :item-guid="exam.guid"
                          @uploaded="uploadFile"
                          :path-url="`/api/de/proxy/general-files/add/category/`"
                          :buttonLabel="$t('Загрузить .xlsx')"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl class="ws-exam-groups-meta__docs__item">
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                        class="ws-field"
                        :label="$t('Тип документа')"
                        :type="{'is-danger': errors.has('type')}"
                        :message="errors.first('type')"
                    >
                      <b-select
                          class="ws-field__control"
                          name="type"
                          :placeholder="$t('')"
                          value='1'
                          expanded
                          disabled
                      >
                        <option
                            value="1"
                            v-text="'Расходные материалы'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-exp-materials'] && files['de-exp-materials'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block"
                          :file="files['de-exp-materials'][0]"
                          :isShowFileDate="true"
                          :buttonLabel="''"
                          @remove="removeFile('de-exp-materials')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                          :disabled="isBlockedStatus || !isMyDeCenter"
                          :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                          class="is-size-3 is-inline-block remove-disabled"
                          :isShowFileDate="true"
                          :file="files['de-exp-materials'][0]"
                          :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin']">
                      <file-upload
                          :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter || !!(files['de-exp-materials'] && files['de-exp-materials'].length)"
                          class="is-full"
                          :category="'de-exp-materials'"
                          :item-guid="exam.guid"
                          @uploaded="uploadFile"
                          :path-url="`/api/de/proxy/general-files/add/category/`"
                          :buttonLabel="$t('Загрузить .xlsx')"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                    </ws-role-node>
                    <!--<ws-role-node :except="['front_me', 'front_dep', 'front_admin']">
                      <span class="has-text-grey">{{ $t('Загружать файлы могут только ДЭ и ГЭ.')}}</span>
                    </ws-role-node>-->
                  </div>
                </div>
              </dl>
              <dl
                class="ws-exam-groups-meta__docs__item"
                v-if="isNoc"
              >
                <div class="columns">
                  <dt class="column is-half">
                    <b-field
                      class="ws-field"
                      :label="$t('Тип документа')"
                      :type="{'is-danger': errors.has('type')}"
                      :message="errors.first('type')"
                    >
                      <b-select
                        class="ws-field__control"
                        name="type"
                        :placeholder="$t('')"
                        value='1'
                        expanded
                        disabled
                      >
                        <option
                          value="1"
                          v-text="'Протокол проведения профессионального экзамена НОК'"
                        ></option>
                      </b-select>
                    </b-field>
                  </dt>
                  <dd class="column is-half align-center" v-if="files['de-docs-noc'] && files['de-docs-noc'].length">
                    <span class="has-text-success has-text-weight-bold mr-5">{{ $t('Загружен')}} </span>
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block"
                        :file="files['de-docs-noc'][0]"
                        :isShowFileDate="true"
                        :buttonLabel="''"
                        @remove="removeFile('de-docs-noc')"
                      />
                    </ws-role-node>
                    <ws-role-node :except="['front_me', 'front_dep', 'front_education_ministry', 'front_admin', 'front_mc']">
                      <file-download
                        :disabled="isBlockedStatus || !isMyDeCenter"
                        :disableDelete="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT"
                        class="is-size-3 is-inline-block remove-disabled"
                        :isShowFileDate="true"
                        :file="files['de-docs-noc'][0]"
                        :buttonLabel="''"
                      />
                    </ws-role-node>
                  </dd>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
                    <file-upload
                      :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
                      class="is-full"
                      :category="'de-docs-noc'"
                      :item-guid="exam.guid"
                      @uploaded="uploadFile"
                      :buttonLabel="$t('Загрузить .pdf')"
                      accept="application/pdf"
                    />
                  </ws-role-node>
                  </div>
                </div>
              </dl>
              <b-loading
                :active="isUploadPending"
                :is-full-page="false"
                :can-cancel="true"
              ></b-loading>
            </div>
          </template>
        </div>
      </div>
      <template v-if="activeTab === 'journal'">
        <ws-exam-logs-list :guid="this.$route.params.id" />
      </template>
    </div>
    <div v-if="activeTab === 'exam'" class="ws-exam-groups">
      <section class="ws-exam-groups__column">
        <!--<div class="columns" v-if="exam">
          <div class="column is-12">
            <files-manager :reqGuid="exam.guid" category="de-reports" :title="$t('Отчеты')" :buttonTitle="$t('Загрузить отчет')" />
            <files-manager :reqGuid="exam.guid" category="de-docs" :title="$t('Акты')" :buttonTitle="$t('Загрузить акт')" />
          </div>
        </div>-->
        <ws-list-view
          class="ws-exam-groups-shifts is-table"
          :class="{ 'is-pending':isGetPending }"
          :data="shifts"
          :header="false"
          :openedDetailed="[...shifts]"
          :detailed="true"
        >
          <template slot-scope="props">
            <ws-list-view-item-column class="is-block">
              <div class="columns is-size-4 is-vcentered">
                <div
                  class="column"
                  v-if="props.row.job_issued_at"
                >
                  <span class="is-size-2">{{ $t('Смена №')}}{{ props.row.number }}</span>
                </div>
                <div
                  class="column has-text-right"
                  v-if="props.row.job_issued_at"
                >
                  <div v-text="$t('Дата выдачи')"></div>
                  <ws-time-formatter
                    :date="props.row.job_issued_at"
                    class="has-text-weight-bold"
                  />
                </div>
                <div
                  class="column has-text-right"
                  v-if="props.row.started_at"
                >
                  <div v-text="$t('Дата начала')"></div>
                  <ws-time-formatter
                    :date="props.row.started_at"
                    class="has-text-weight-bold"
                  />
                </div>
                <div
                  class="column has-text-right"
                  v-if="props.row.ended_at"
                >
                  <div v-text="$t('Дата окончания')"></div>
                  <ws-time-formatter
                    :date="props.row.ended_at"
                    class="has-text-weight-bold"
                  />
                </div>
              </div>
              <div
                class="ws-exam-groups-shifts__is_remote is-size-5"
                v-if="isRemoteParticipants"
              >
                {{$t('Участники присутствуют на ДЭ дистанционно (удаленно)')}}
              </div>
            </ws-list-view-item-column>
          </template>
          <template
            slot="details"
            slot-scope="props"
          >
            <ws-exam-groups-list-item-details
              :props="props"
              :isMyDeCenter="isMyDeCenter"
              :curators="curators[exam.de_center.parent.guid]"
              :exam="exam"
              :selected.sync="selected"
              @sisImported="_fetch()"
            />
          </template>
        </ws-list-view>
      </section>
      <section class="ws-participants">
        <template v-if="selected">
          <ws-role-node :only="['front_mio', 'front_50plus']">
            <ws-participants-import
              format="xlsx"
              name="users"
              :disabled="exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || exam.status === constants.exam_status.APPROVED_MAIN_EXPERT || isBlockedStatus || !isMyDeCenter"
              @input-users="onImportUsers"
            >
            </ws-participants-import>
          </ws-role-node>
          <div :class="{'ws-study-groups__column__mio__admin50plus': currentRole === 'front_mio' || currentRole === 'front_50plus'}">
            <ws-exam-groups-participants-list
              :selectedItems="selected.participants || []"
              :exam="exam"
              :groups="groups"
              :current="selected"
              :isMyDeCenter="isMyDeCenter"
              :disabled = "(currentRole !== 'front_me' && exam.status === constants.exam_status.APPROVED_MAIN_EXPERT) || exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT || isBlockedStatus"
              :items="participantsList"
              @input-users="updateGroupUsersList"
              @onChangeParticipantsRetakeExam="onChangeParticipantsRetakeExam"
            />
          </div>
        </template>
        <template v-else>
          <p
            class="has-text-centered"
            v-text="$t('Выберите группу')"
          ></p>
        </template>
      </section>
    </div>
    <b-loading
      :is-full-page="false"
      :active="isMy ? isMyGetPending : isGetPending"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import getPhoneNumber from '@/utils/getPhoneNumber'
import getAddress from '@/utils/getAddress'
import WsDemoExamsApprove from '@/components/de/demo-exams/WsDemoExamsApprove'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
import { constants } from '@/services/constants.service'
import { toUTCDay } from '@/utils/helpers'
import { get } from 'lodash-es'
import FileUpload from '@/components/common/file/FileUpload'
import FileDownload from '@/components/common/file/FileDownload'
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
import WsDemoExamStatus from './WsDemoExamStatus.vue'
import WsExpertsList from './WsExpertsList.vue'
import WsExamParticipantsInfo from './WsExamParticipantsInfo.vue'
import WsExamLogsList from './WsExamLogsList.vue'
import WsReadinessCPDEForm from '@/components/de/demo-exams/WsReadinessCPDEForm.vue'

export default {
  name: 'WsExamGroupsList',
  components: {
    WsReadinessCPDEForm,
    FileDownload,
    FileUpload,
    WsDemoExamsApprove,
    WsDemoExamStatus,
    WsExpertsList,
    WsExamParticipantsInfo,
    WsExamLogsList
  },
  mixins: [isBlockedExam],
  data () {
    return {
      videoLinks: [],
      comments: [],
      isDisableExamGroupsControls: false,
      isStatusUpdating: false,
      selected: null,
      shifts: [],
      groups: [],
      isUploadPending: false,
      files: {
        'de-reports': [],
        'de-docs': [],
        'de-docs-noc': [],
        'de-exp-materials': [],
        'de-mto': [],
        'de-docs-passport': [],
        'de-docs-mto': []
      },
      exam: null,
      activeTab: 'exam',
      constants,
      tabs: [
        {
          title: this.$t('Экзамен'),
          link: 'exam'
        },
        {
          title: this.$t('Эксперты'),
          link: 'experts'
        },
        {
          title: this.$t('Документы'),
          link: 'documents'
        }
      ],
      curators: {}
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid', 'currentRole']),
    ...mapGetters('exams', {
      getExamById: 'get'
    }),
    ...mapState('exams', {
      isGetPending: 'isGetPending'
    }),
    ...mapGetters('my-exams', {
      getMyExamById: 'get'
    }),
    ...mapState('my-exams', {
      isMyGetPending: 'isGetPending'
    }),
    ...mapState('authentication', {
      currentRole: 'currentRole'
    }),
    expert () {
      return this.exam.main_expert
    },
    isExam50Plus () {
      return this.exam.flags.indexOf('50_plus') > -1 || this.exam.flags.indexOf('master_of_industrial_edu') > -1
    },
    isSingleGroup () {
      return this.getGroups.length === 1
    },
    getGroups () {
      return this.shifts.map(item => item.groups).flat()
    },
    getExamGuid () {
      return this.$route.params.id
    },
    getParticipants () {
      const groups = this.exam.shifts ? [...this.exam.shifts.map(item => item.groups || [])].flat() : []
      return groups.map(group => group.participants || []).flat()
    },
    getApprovedParticipants () {
      return !!(this.getParticipants.filter(user => user.status === 'approved').length)
    },
    isNoc () {
      return this.exam.flags.indexOf('independent_estimate') > -1
    },
    getMainExpertStatusUpdateDate () {
      if (this.exam.main_expert && this.exam.logging && this.exam.logging.length) {
        const action = this.exam.main_expert.accepted ? 'accept' : 'reject'
        const foundLogs = this.exam.logging.filter(entry => {
          return entry.action === action
        }).sort((a, b) => {
          return new Date(a.created_at) > new Date(b.created_at)
        })
        if (foundLogs.length) {
          return toUTCDay(new Date(foundLogs[0].created_at)).toISOString()
        }
      }
      return null
    },
    isRemoteParticipants () {
      return this.exam.flags.indexOf('remote_members') > -1
    },
    isMyDeCenter () {
      // return true
      const hasCurators = Object.keys(this.curators).length
      if (this.currentRole !== 'front_curator') return true
      if (!hasCurators) return false

      const { guid } = (this.exam.shifts[0] &&
        this.exam.shifts[0].groups[0] &&
        this.exam.shifts[0].groups[0].university &&
        this.exam.shifts[0].groups[0].university) ? this.exam.shifts[0].groups[0].university : this.exam.de_center.parent

      const isCurator = this.curators[guid].findIndex(item => item.guid === this.getUserGuid) > -1
      return this.currentRole === 'front_curator' ? isCurator : true
    },
    isMy () {
      return this.currentRole === 'front_me' || this.currentRole === 'front_le' || this.currentRole === 'front_tech_expert'
    },
    docCounting () {
      let total = 6
      const count = Object.entries(this.files).filter(function ([key, value]) {
        if (key === 'docs-noc' && this.isNoc) {
          total++
          return !!(value && value.length)
        } else if (key !== 'docs-noc') {
          return !!(value && value.length)
        }
        return false
      }.bind(this)).length

      return {
        total,
        count
      }
    },
    participantsList () {
      const eduGroup = this.selected.education_group || null
      const participants = this.selected.participants || []
      let groupParticipants = []

      if (eduGroup && eduGroup.participants) {
        groupParticipants = eduGroup.participants
      }
      return [...participants, ...groupParticipants]
    }
  },
  methods: {
    ...mapActions('exams', ['get', 'update', 'create',
      'updateParticipantsList',
      'updateParticipantStatus',
      'updateParticipant'
    ]),
    ...mapActions('my-exams', {
      getMy: 'get'
    }),
    ...mapActions('exams/shifts', {
      updateGroup: 'update'
    }),
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId',
      removeFileByRecId: 'removeFileByRecId',
      requestGetLinks: 'getLinks',
      requestPostLink: 'postLink',
      requestPutLink: 'putLink',
      requestDeleteLink: 'deleteLink',
      requestGetComments: 'getComments',
      requestPostComment: 'postComment',
      requestPutComment: 'putComment',
      requestDeleteComment: 'deleteComment'
    }),
    ...mapActions('refbook/curators', {
      'findCurators': 'create'
    }),
    getPhoneNumber,
    getAddress,
    addNewLink () {
      if (this.videoLinks.length < 20) {
        this.videoLinks.push({
          link: '',
          isOpen: true,
          guid: null
        })
      }
    },
    isDeCenterAccredited (exam) {
      return isDeCenterAccredited(exam.accred_comps, exam.flags)
    },
    getTechnicalExpertPhoneNumbers (expert) {
      const phoneNumbers = get(expert, 'user_info.profile.contacts.communication.phone')
      if (phoneNumbers && phoneNumbers.length) {
        return phoneNumbers.reduce((str, number, index) => {
          if (index) {
            str += ' ,'
          }
          str += number.value
          return str
        }, '')
      }
      return null
    },
    async onChangeParticipantsRetakeExam (elem) {
      this.updateGroupUsersList({ action: 'update', users: [elem] })
    },
    async updateGroupUsersList (options) {
      if (options.action === 'update-participant') {
        try {
          const newParticipant = await this.updateParticipant({
            examGuid: this.exam.guid,
            shiftGuid: this.selected.shift.guid,
            groupGuid: this.selected.guid,
            participantGuid: options.user.guid,
            data: options
          })

          const participant = this.selected.participants.find(participant => participant.guid === newParticipant.guid)
          if (participant) {
            Object.assign(participant, newParticipant)
          }
        } catch (e) {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так`),
            type: 'is-danger'
          })
        }
        return
      }
      if (options.action === 'update-status') {
        try {
          const newParticipant = await this.updateParticipantStatus({
            examGuid: this.exam.guid,
            shiftGuid: this.selected.shift.guid,
            groupGuid: this.selected.guid,
            participantGuid: options.user.guid,
            status: options.status
          })

          const participant = this.selected.participants.find(participant => participant.guid === newParticipant.guid)
          if (participant) {
            Object.assign(participant, newParticipant)
          }
        } catch (e) {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так`),
            type: 'is-danger'
          })
        }
        return
      }
      if (options.action === 'update-participant-file') {
        return
      }
      try {
        const group = await this.update([this.getExamGuid, {
          [options.action]: [
            ...options.users.map((user) => {
              if (options.action === 'delete') {
                return user.user_info.guid
              }
              return { id: user.user_info.guid,
                is_retake_exam: user.is_retake_exam
              }
            })
          ]
        }, `/shifts/${this.selected.shift.guid}/groups/${this.selected.guid}/participants`])
        this.selected.participants = group.participants
        this.$buefy.toast.open({
          message: this.$t(`Группа успешно обновлена`),
          type: 'is-success'
        })
      } catch (e) {
        console.log('e', e)
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
      this.exam = await this.get([this.getExamGuid])
      this.prepareShifts()
      await this.$emit('exam-details', { exam: this.exam })
    },
    isCanApprove (exam) {
      return this.getApprovedParticipants &&
        !!exam.main_expert &&
        exam.experts &&
        exam.experts.find(e => e.accepted)
    },
    async onImportUsers (users) {
      if (users && users.length) {
        let usersToImport
        if (this.selected.participants) {
          usersToImport = users.map(u => u.guid).filter(u => !this.selected.participants.some(s => s.user_info && s.user_info.guid === u))
        } else {
          usersToImport = users.map(u => u.guid)
        }
        if (usersToImport.length) {
          let updatedGroup = await this.updateParticipantsList({
            params: {
              examGuid: this.exam.guid,
              shiftGuid: this.selected.shift.guid,
              groupGuid: this.selected.guid
            },
            data: {
              update: usersToImport
            }
          })

          updatedGroup = await this.updateGroup([this.exam.guid, {
            'student': updatedGroup.participants ? updatedGroup.participants.length : 0,
            'shift': {
              'guid': updatedGroup.shift.guid
            }
          }, `/shifts/${updatedGroup.shift.guid}/groups/${updatedGroup.guid}`])

          this.selected = updatedGroup
          this._fetch()
        }
      }
    },
    async updateExamStatus (exam, status) {
      this.isStatusUpdating = true
      await this.update([exam.guid, [], `/status/${status}`])
      this.isStatusUpdating = false
    },
    async _fetch () {
      this.exam = await this.get([this.getExamGuid])
      this.prepareShifts()
      this.getFiles()
      await this.$emit('exam-details', { exam: this.exam })
      if (this.isSingleGroup) {
        this.selected = this.getGroups[0]
      }

      const { guid } = (this.exam.shifts[0] &&
        this.exam.shifts[0].groups[0] &&
        this.exam.shifts[0].groups[0].university &&
        this.exam.shifts[0].groups[0].university) ? this.exam.shifts[0].groups[0].university : this.exam.de_center.parent
      if (guid && guid !== constants.NULL_GUID && this.currentRole !== 'front_me') {
        this.curators = await this.findCurators([ [guid], '/list' ])
      }
    },
    prepareShifts () {
      this.shifts = [...(this.exam.shifts ? this.exam.shifts : [])]
      this.groups = this.shifts ? [...this.shifts.map(item => {
        const groups = item.groups || []
        if (groups.length) {
          groups.forEach(group => {
            Object.assign(group, {
              parent: {
                'shift-guid': item.guid,
                'shift-number': item.number,
                'cis-url': item['cis-url'],
                'task-file': item['task-file'],
                'max_score': item['max_score'],
                'max_wsss_score': item['max_wsss_score']
              }
            })
          })
        }
        return groups
      })].reduce((acc, val) => acc.concat(val), []) : []
    },
    async getFiles () {
      this.isUploadPending = true
      const arrRequests = Object.keys(this.files)
        .filter(elem => elem !== 'docs-noc' || (elem === 'docs-noc' && this.isNoc))
        .map(elem => this.getFile(elem))
      await Promise.all(arrRequests).finally(() => {
        this.isUploadPending = false
      })
    },
    async getFile (category) {
      const files = await this.getFileByRecId({
        'rec-guid': this.exam.guid,
        'category': category
      })
      this.files[category] = files
    },
    async uploadFile (files, category) {
      this.files[category] = files
    },
    async removeFile (category) {
      const file = this.files[category][0]
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить файл ${file.file_name}?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async function () {
          try {
            this.isPending = true
            await this.removeFileByRecId({
              isProxy: true,
              'rec-guid': this.exam.guid,
              'category': category,
              'file-guid': file.guid
            })
            this.files[category] = []
          } catch (e) {
            console.log(e)
          }
        }.bind(this)
      })
    },
    openLink (index) {
      this.videoLinks[index].isOpen = true
    },
    openComment (index) {
      this.comments[index].isOpen = true
    },
    async getLinks () {
      this.videoLinks = []
      try {
        let links = await this.requestGetLinks({ examGUID: this.exam.guid })
        links.forEach(el => { this.videoLinks.push({ ...el, isOpen: false }) })
      } catch (error) {
        console.log(error)
      }
    },
    async saveLink (item, index) {
      if (!item.link) {
        this.deleteLink(item, index)
      } else {
        if (item.guid) this.putLink(item, index)
        else this.postLink(item, index)
      }
    },
    async postLink (item, index) {
      try {
        let res = await this.requestPostLink({
          examGUID: this.exam.guid,
          link: item.link
        })
        this.videoLinks[index].isOpen = false
        this.videoLinks[index].guid = res.guid
      } catch (error) {
        this.showError(error)
      }
    },
    async putLink (item, index) {
      try {
        let res = await this.requestPutLink({
          examGUID: this.exam.guid,
          link: item.link,
          guid: item.guid
        })
        this.videoLinks[index].isOpen = false
        this.videoLinks[index].guid = res.guid
      } catch (error) {
        this.showError(error)
      }
    },
    async deleteLink (item, index) {
      if (item.guid) {
        try {
          await this.requestDeleteLink({
            examGUID: this.exam.guid,
            guid: item.guid
          })
          this.videoLinks.splice(index, 1)
        } catch (error) {
          this.showError(error)
        }
      } else {
        this.videoLinks.splice(index, 1)
      }
    },
    async getComments () {
      this.comments = []
      try {
        let comments = await this.requestGetComments({
          examGUID: this.exam.guid
        })
        comments.forEach(el => { this.comments.push({ ...el, isOpen: false }) })
        if (!comments.length) {
          let arr = [{ guid: null, comment: '' }]
          arr.forEach(el => { this.comments.push({ ...el, isOpen: true }) })
        }
      } catch (error) {
        let arr = [{ guid: null, comment: '' }]
        arr.forEach(el => { this.comments.push({ ...el, isOpen: true }) })
        this.showError(error)
      }
    },
    async saveComment (item, index) {
      if (!item.comment) {
        this.deleteComment(item, index)
      } else {
        if (item.guid) this.putComment(item, index)
        else this.postComment(item, index)
      };
    },
    async postComment (item, index) {
      try {
        let res = await this.requestPostComment({
          examGUID: this.exam.guid,
          comment: item.comment
        })
        this.comments[index].isOpen = false
        this.comments[index].guid = res.guid
      } catch (error) {
        this.showError(error)
      }
    },
    async putComment (item, index) {
      try {
        let res = await this.requestPutComment({
          examGUID: this.exam.guid,
          comment: item.comment,
          guid: item.guid
        })
        this.comments[index].isOpen = false
        this.comments[index].guid = res.guid
      } catch (error) {
        this.showError(error)
      }
    },
    async deleteComment (item, index) {
      if (item.guid) {
        try {
          await this.requestDeleteComment({
            examGUID: this.exam.guid,
            guid: item.guid
          })
          this.comments.splice(index, 1)
          let arr = [{ guid: null, comment: '' }]
          arr.forEach(el => { this.comments.push({ ...el, isOpen: true }) })
        } catch (error) {
          this.showError(error)
        }
      } else {
        item.comment = ''
      }
    },
    showError (error) {
      const ERRORS_OPTIONS = {
        message: 'Something happend',
        type: 'is-danger',
        duration: 5000,
        position: 'is-top',
        queue: false
      }
      let message = `${error.status} | ${error.data.error.message}`
      Snackbar.open({ ...ERRORS_OPTIONS, message })
    }
  },
  async mounted () {
    await this._fetch()
    await this.getLinks()
    await this.getComments()
  }
}
</script>

<style lang="scss">
.ws-participants{
  overflow: auto;
}

.comments {
  margin: 10px 0;
  .comment {
    display: flex;
  }
  .commentText {
    padding: 10px 0;
    max-height: 300px;
    max-width: 60vw;
    overflow-y: auto;
  }
  textarea {
    resize: none;
    background-color: #ecf1f8;
    border-color: #cedaef;
    padding: 5px;
    outline: none;
    font-size: 16px;
    border-radius: 4px;
    width: 35vw;
    min-width: 350px;
    &:focus {
      border-color: #000;
      box-shadow: 0 0 0 0.125em rgba(0, 0, 0, 0.25);
    }
  }

  .ws-button__icon {
    margin-left: 10px;
    cursor: pointer;
  }
}

.videoLink {
  margin-top: 5px;
  display: flex;
  align-items: center;
  .description {
    color: grey;
  }
  input {
    width: 35vw;
    min-width: 350px;
  }
  .ws-button__icon {
    margin-left: 10px;
    cursor: pointer;
  }
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 60vw;
  }
}

.tabs {
  margin-top: 1.2rem;

  @media screen and (min-width: 769px) {
    margin-top: -2rem;
  }

  &__content {
    > * + * {
      margin-left: 3rem;
    }
  }

  &__item {
    cursor: pointer;
    margin-bottom: 5px;
    position: relative;
    font-family: ArialNarrow, sans-serif;
    font-size: 18px;

    &.active {
      border-bottom: 3px solid rgb(81, 76, 76);
    }

    .doc-count {
      position: absolute;
      right: -45px;
    }
  }
}

.m-expert {
  margin: 2rem 0;

  &__title {
    margin-bottom: 1rem;
    font-family: ArialNarrow, sans-serif;
  }

  &__content {
    margin-left: 0.5rem;
  }
}

.ws-exam-groups-meta__evaluation-system {
  &_old {
    color: #7a7a7a;
  }

  &_new-cis {
    color: #5495b7;
  }
}

.ws-exam-groups-meta__evaluation-system-name {
  font-weight: bold;
}

.ws-exam-groups-meta__docs dd.align-center {
  display: flex;
  align-items: center;
}

.new-docs .ws-exam-groups-meta__docs__item .ws-field .select select[disabled] {
  color: #000;
}

.new-docs.ws-exam-groups-meta__docs .file-upload__wrapper .ws-button {
  height: 2.5rem;
}

.new-docs .ws-exam-groups-meta__docs__item {
  padding: 15px 0 30px;
}

.mr-5 {
  margin-right: 5px;
}

.ml-5 {
  margin-left: 5rem;
}

.new-docs .ws-exam-groups-meta__docs__title {
  color: #1c3b8d;
}
</style>
